/**
 * Utility functions for managing Draft order storage
 */

const getLS_DRAFT_PROJECT_ID = (userId: string) => `order.draftProjectId.${userId}`;
const getLS_STEP = (userId: string) => `order.step.${userId}`;
const getLS_MAX_STEP = (userId: string) => `order.maxStep.${userId}`;
const getLS_DRAFT = (userId: string) => `order.draft.${userId}`;

/**
 * Clear all draft-related data from localStorage for a user.
 * Call this before starting a new order to ensure clean state.
 */
export function clearDraftStorage(userId: string | number | undefined | null): void {
  if (!userId) return;
  
  const id = String(userId);
  try {
    localStorage.removeItem(getLS_DRAFT_PROJECT_ID(id));
    localStorage.removeItem(getLS_STEP(id));
    localStorage.removeItem(getLS_MAX_STEP(id));
    localStorage.removeItem(getLS_DRAFT(id));
  } catch (e) {
    // Ignore localStorage errors
  }
}

/**
 * Get the draft project ID from localStorage
 */
export function getDraftProjectId(userId: string | number | undefined | null): string | null {
  if (!userId) return null;
  
  try {
    return localStorage.getItem(getLS_DRAFT_PROJECT_ID(String(userId)));
  } catch (e) {
    return null;
  }
}

/**
 * Save draft project ID to localStorage
 */
export function saveDraftProjectIdToStorage(userId: string | number, draftId: string): void {
  try {
    localStorage.setItem(getLS_DRAFT_PROJECT_ID(String(userId)), draftId);
  } catch (e) {
    // Ignore localStorage errors
  }
}
